import _clone from 'lodash/clone';
import React, { useState } from 'react';
import { useAppSelector, useSnackbar } from 'src/utils/Hooks';

import { SlMenu, useStacklineTheme } from '@stackline/ui';
import { useDispatch } from 'react-redux';
import { updatePortfolio } from 'src/components/AdManager/AmsUtils';
import { DynamicDownChevron } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/DynamicDownChevron';
import { CustomLoading } from 'src/components/common/Loading/PlaceHolderLoading/PlaceHolderLoading';
import { fetchAdPortfolios } from 'src/store/modules/adManager/adPortfolios/operations';
import { fetchMainEntity } from 'src/store/modules/entityService/operations';
import { AD_AUTOMATION_TYPE_EDIT_DISABLED } from 'src/utils/app';

const PortfolioOptimization = () => {
  const { showSnackbar } = useSnackbar();
  const theme = useStacklineTheme();
  const adPlatformSettings = useAppSelector((state) => state.adPlatformSettings);

  const adStrategies = adPlatformSettings.filter((item) => item.settingType === 'campaignStrategy');

  const dropdownOptions = adStrategies
    .filter((s) => {
      return s.id !== 'MaximizeMargin' && s.id !== 'MaximizeIncrementalMargin';
    })
    .map((strategy) => ({
      id: strategy.id,
      label: strategy.name
    }));

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const currentEntity = useAppSelector((state) => state.entityService.mainEntity);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const currentStrategyId = currentEntity?.extendedAttributes?.automationAttributes?.strategyId;
  const currentStrategy = adStrategies.find((strategy) => strategy.id === currentStrategyId);

  const saveOptimization = async (id: string) => {
    if (id === currentStrategyId) {
      return;
    }
    try {
      const mainEntityCloned: any = _clone(currentEntity);
      mainEntityCloned.extendedAttributes.automationAttributes.strategyId = id;
      setLoading(true);

      await updatePortfolio(mainEntityCloned);
      await dispatch(
        fetchMainEntity(mainEntityCloned.type, mainEntityCloned.id, mainEntityCloned.extendedAttributes.retailerId)
      );
      await dispatch(fetchAdPortfolios());
      showSnackbar({
        message: 'Optimization saved successfully.',
        type: 'success'
      });

      setLoading(false);
    } catch (error) {
      showSnackbar({
        message: 'Error saving optimization, please try again later.',
        type: 'error'
      });
      console.error('Error saving budget', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div
        className="field-title"
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '12px'
        }}
      >
        Optimization
      </div>
      <div className="field-subtitle">
        {loading ? (
          <CustomLoading height={12} width={88} padding={0} />
        ) : AD_AUTOMATION_TYPE_EDIT_DISABLED ? (
          <div>{currentStrategy?.name}</div>
        ) : (
          <div>
            <button
              onClick={handleClick}
              style={{
                width: '100%',
                background: 'none',
                padding: '0',
                color: theme.colors.primary,
                outline: 'none',
                border: 'none',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <div> {currentStrategy?.name}</div>

              <div>
                {anchorEl ? (
                  <DynamicDownChevron
                    strokeWidth="2px"
                    color={theme.colors.primary}
                    style={{ transform: 'rotate(180deg)', verticalAlign: 'bottom' }}
                  />
                ) : (
                  <DynamicDownChevron
                    strokeWidth="2px"
                    color={theme.colors.primary}
                    style={{ verticalAlign: 'bottom' }}
                  />
                )}
              </div>
            </button>
            <SlMenu
              anchorEl={anchorEl}
              open={!!anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
              }}
              options={dropdownOptions}
              selectedId={currentStrategyId}
              onChange={(opt) => {
                saveOptimization(opt.id);
              }}
              sx={{
                marginTop: '6px',
                '& ul': {
                  boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.15)',
                  paddingY: 0
                },
                '.MuiPaper-root': {
                  maxHeight: 'calc(100% - 59px)',

                  paddingRight: 0,
                  boxSizing: 'border-box',
                  '&::-webkit-scrollbar': { display: 'none' }
                },
                '&::-webkit-scrollbar': { display: 'none' }
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PortfolioOptimization;
